<template>
  <div>
    <div class="ui three item top attached tabular menu" ref="tabs">
      <a class="active item" data-tab="html">
        <i class="html5 icon"></i> {{ $t("html") }}</a
      >
      <a class="item" data-tab="mixin">
        <i class="js icon"></i> {{ $t("mixin") }}</a
      >
      <a class="item" data-tab="validation">
        <i class="check icon"></i> {{ $t("validation") }}</a
      >
    </div>
    <div class="ui bottom attached active tab segment" data-tab="html">
      <tpl-manager
        type="html"
        icon="html5"
        :title="$t('html code')"
        :templates="templates.filter((t) => t.type == 'html')"
      />
    </div>
    <div class="ui bottom attached tab segment" data-tab="mixin">
      <tpl-manager
        type="javascript"
        icon="js"
        :title="$t('mixin')"
        :templates="templates.filter((t) => t.type == 'mixin')"
      />
    </div>
    <div class="ui bottom attached tab segment" data-tab="validation">
      <tpl-manager
        type="javascript"
        icon="check"
        :title="$t('validation')"
        :templates="templates.filter((t) => t.type == 'validation')"
      />
    </div>
  </div>
</template>

<script>
import { local_api, toast } from "@/utils";
import TplManager from "./TplManager.vue";

export default {
  name: "TemplatesManagement",
  components: { TplManager },
  computed: {},
  props: {},
  data() {
    return {
      templates: [],
    };
  },
  methods: {},
  created() {
    let vm = this;

    local_api(this, "post", "/system/do-get-templates")
      .then((templates) => {
        vm.templates = templates;
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.currency_dropdown).dropdown();
    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
    // }, 200);
  },
  watch: {},
  updated: function() {},
};
</script>
